import { useQuery } from "@tanstack/react-query";
import { getCompanyIdForDriver } from "@/api/locations";
import { qk } from "@/api/queryKeys";
import { useCompany } from "@/features/companies/hooks/use-companies";

/**
 * The subcontractor a driver belongs to, found via their assigned card —
 * `undefined` while resolving, `null` if they have no (live) company.
 * `driverEmail` of `""` skips the lookup (non-driver sessions). Shares its
 * company-id query with the map's discount-settings lookup.
 */
export function useDriverCompanyName(driverEmail: string): string | null | undefined {
  const companyIdQuery = useQuery({
    queryKey: qk.map.driverCompanyId(driverEmail),
    queryFn: () => getCompanyIdForDriver(driverEmail),
    enabled: driverEmail !== "",
  });
  const companyId = companyIdQuery.data ?? null;
  const companyQuery = useCompany(companyId);

  if (driverEmail === "") {
    return null;
  }
  if (companyIdQuery.isPending) {
    return undefined;
  }
  if (companyId === null) {
    return null;
  }
  if (companyQuery.isPending) {
    return undefined;
  }
  return companyQuery.data?.name ?? null;
}
